import React from 'react';
import styles from '../index.module.css';

interface ReasonForVisitEmptyStateProps {
  inputString: string;
}

const noResultsPrefix = 'No results for: “';
const noResultsSuffix = '”';
const nextStepsText =
  'Please refine your search term and select a reason for your visit.';

export const ReasonForVisitEmptyState: React.FC<
  ReasonForVisitEmptyStateProps
> = (props) => {
  return (
    <div className={styles.EmptyState}>
      <div className={styles.StandardText}>
        {noResultsPrefix}
        <span className={styles.HighlightedText}>{props.inputString}</span>
        {noResultsSuffix}
      </div>
      <div className={styles.StandardText}>{nextStepsText}</div>
    </div>
  );
};
